import { feedItems, siteBrand } from "@/mocks/news";

const stats = [
  { label: "今日新增", value: `${feedItems.filter((i) => i.date === "今日").length}` , unit: "条" },
  { label: "追踪中", value: `${feedItems.filter((i) => i.status === "追踪中").length}`, unit: "条" },
  { label: "覆盖分类", value: "6", unit: "个" },
];

export default function HeroSection() {
  return (
    <section id="top" className="relative w-full overflow-hidden border-b border-background-200 bg-background-50">
      <div className="pointer-events-none absolute -right-24 -top-24 h-72 w-72 rounded-full bg-accent-100/60 blur-3xl"></div>
      <div className="pointer-events-none absolute -left-32 bottom-0 h-72 w-72 rounded-full bg-primary-100/50 blur-3xl"></div>

      <div className="relative mx-auto grid w-full max-w-[1400px] grid-cols-1 items-center gap-10 px-4 py-14 md:px-6 md:py-20 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-7">
          <span className="inline-flex items-center gap-2 rounded-full border border-primary-200 bg-primary-50 px-3.5 py-1.5 text-xs font-medium text-primary-700">
            <span className="live-dot h-2 w-2 rounded-full bg-primary-500"></span>
            实时滚动页 · 每一点进展都能及时刷到
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-[1.25] tracking-tight text-foreground-950 md:text-4xl lg:text-5xl">
            黑料今日，
            <br />
            把还在发酵的<span className="text-primary-600">突发消息</span>推上来
          </h1>

          <p className="mt-5 max-w-xl text-base leading-relaxed text-foreground-700 md:text-[17px]">
            {siteBrand.intro}
          </p>

          <div className="mt-7 flex flex-col gap-3 sm:flex-row sm:items-center">
            <a
              href="#live"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-live-line"></i>
              进入实时滚动
            </a>
            <a
              href="#hot"
              className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors hover:bg-background-100"
            >
              <i className="ri-fire-line text-primary-500"></i>
              查看热门榜单
            </a>
          </div>

          <dl className="mt-9 grid max-w-md grid-cols-3 gap-4 border-t border-background-200 pt-6">
            {stats.map((stat) => (
              <div key={stat.label}>
                <dd className="font-heading text-2xl font-bold text-foreground-950">
                  {stat.value}
                  <span className="ml-0.5 text-xs font-normal text-foreground-500">{stat.unit}</span>
                </dd>
                <dt className="mt-1 text-xs text-foreground-600">{stat.label}</dt>
              </div>
            ))}
          </dl>
        </div>

        <div className="lg:col-span-5">
          <div className="relative overflow-hidden rounded-lg border border-background-200 bg-background-100">
            <div className="relative h-[300px] w-full md:h-[420px] lg:h-[460px]">
              <img
                src="https://readdy.ai/api/search-image?query=abstract%20editorial%20illustration%20of%20warm%20spotlights%20and%20broadcast%20signal%20waves%20radiating%20over%20cream%20and%20vermilion%20color%20blocks%2C%20layered%20paper%20cut%20style%2C%20bold%20minimal%20geometric%20shapes%2C%20energetic%20but%20clean%20composition%2C%20no%20text%2C%20warm%20high%20contrast%20palette&width=900&height=1120&seq=hero-newsroom-01&orientation=portrait"
                alt="抽象插画：暖色聚光灯与信号波纹交叠，象征实时更新的热点资讯"
                className="h-full w-full object-top"
              />
            </div>
            <div className="absolute bottom-4 left-4 right-4 rounded-md border border-background-200 bg-background-50/95 p-4 backdrop-blur">
              <div className="flex items-center justify-between gap-3">
                <span className="flex items-center gap-2 text-xs font-medium text-primary-700">
                  <i className="ri-flashlight-fill text-accent-500"></i>
                  刚刚更新
                </span>
                <span className="text-xs text-foreground-500">14:32</span>
              </div>
              <p className="mt-2 font-heading text-sm font-semibold leading-snug text-foreground-950">
                新剧《长夜灯火》官方确认调整上线档期
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}